/**
 * Associations Module
 */
 import Vue from 'vue';
 import router from '../../../router/router';
 import { apiModel, makeApiRequest } from "../../../api";
 import Swal from "sweetalert2";
 import AppConfig from "../../../constants/AppConfig";
 import {store} from "../../store";
 // States
 const state = {
     Associations: [],
     Association: {}
 };
 
 // Getters
 const getters = {
     Associations: state => {
         return state.Associations
     },
 
     Association: state => {
         return state.Association
     }
 };
 
 // Actions
 const actions = {
     getAssociations(context, payload) {
         function successCallback(response) {
             context.commit('getAssociationsHandler', { Associations: response.data.associations });
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         return makeApiRequest(payload.args, apiModel.Association.List, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
     getAssociation(context, payload) {
         function successCallback(response) {
             context.commit('getAssociationHandler', { Association: response.data.association });
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Association.Get, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
     createAssociation(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
             if(response.data.hasOwnProperty('message')){
                 Swal.fire(
                     response.data.message,
                     '',
                     'warning'
                 );
             }
             router.push({ name: 'association', params: { association: response.data.association.slug } });
         }
 
         function errorCallback(error) {
             store.dispatch('record', {errors : error.response.data.error});
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         // makeApiRequest(payload.args, apiModel.Association.Create, localToken, successCallback, errorCallback, payload.errorMessages);
         let url = AppConfig.apiUrl + apiModel.Association.Create.url;
 
         Vue.axios.post(
             url,
             payload.args,
             {
                 headers: {
                     'Authorization': `Bearer ${localToken}`,
                     'Content-Type': 'multipart/form-data'
                 }
             }
         )
             .then(successCallback)
             .catch(errorCallback);
         },
 
     updateAssociation(context, payload) {
         function successCallback(response) {
           
             store.dispatch('findAndRemove', {name: 'association' });
             router.push({ name: 'association', params: { association: response.data.association.slug } });
 
         }
 
         function errorCallback(error) {
             store.dispatch('record', {errors : error.response.data.error});
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
          makeApiRequest(payload.args, apiModel.Association.Update, localToken, successCallback, errorCallback, payload.errorMessages);
 
       /*  let url = AppConfig.apiUrl + apiModel.Association.Update.url + '/' + payload.association;
 
         Vue.axios.put(
             url,
             payload.args,
             {
                 headers: {
                     'Authorization': `Bearer ${localToken}`,
                     'Content-Type': 'multipart/form-data'
                 }
             }
         )
             .then(successCallback)
             .catch(errorCallback);*/
     },
 
     deleteAssociation(context, payload) {
         function successCallback(response) {
             router.push({ name: 'Associations' });
             //    context.commit('deleteAssociationHandler', { index: payload.index, successMessage: payload.successMessage });
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Association.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 };
 
 // Mutations
 const mutations = {
     getAssociationsHandler(state, { Associations }) {
         // Update Associations state
         state.Associations = Associations;
     },
     getAssociationHandler(state, { Association }) {
         // Update Association state
         state.Association = Association;
     },
 
     deleteAssociationHandler(state, { index, successMessage }) {
         let i = state.Associations.findIndex(Association => Association.slug === index);
 
         if (~i) {
             state.Associations.splice(i, 1);
 
             router.push({ name: 'Associations' });
 
             Vue.swal(
                 successMessage,
                 '',
                 'success'
             );
         }
     }
 };
 
 export default {
     state,
     getters,
     actions,
     mutations
 }